module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pl-dialog', {
    attrs: {
      "title": "New Instruction",
      "size": "relative_sm",
      "isBeta": true,
      "disableOutsideClick": true
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "w-full h-full flex flex-col justify-between space-y-5 px-5 overflow-y-auto pb-4 -mt-2"
  }, [_c('div', [_c('p', {
    staticClass: "text-sm text-gray-600 font-manrope"
  }, [_vm._v("Instruct the Genie to give feedback in a custom way. For example, \"simplify feedback for English Language Learners\", \"ask a question about the student's thinking\" or \"make it silly\".")])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col space-y-3 ml-1"
  }, [_c('div', {
    staticClass: "w-full font-manrope flex flex-col space-y-2"
  }, [_c('label', {
    staticClass: "text-sm text-gray-800"
  }, [_vm._v("Name "), _c('span', {
    staticClass: "text-red-500"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "flex w-full items-center bg-gray-100 rounded-md focus-within:ring-2 focus-within:ring-primary focus-within:ring-offset-2 focus-within:ring-offset-primary-new_light transition-all duration-150 ease-in-out"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.instruction.name),
      expression: "instruction.name"
    }],
    staticClass: "bg-transparent px-3 py-1.5 rounded-md focus:outline-none w-full",
    attrs: {
      "placeholder": "Enter a instruction title...",
      "type": "text"
    },
    domProps: {
      "value": (_vm.instruction.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.instruction, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "w-full font-manrope flex flex-col space-y-2"
  }, [_c('label', {
    staticClass: "text-sm text-gray-800"
  }, [_vm._v("Instruction "), _c('span', {
    staticClass: "text-red-500"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "w-full bg-gray-100 rounded-md focus-within:ring-2 focus-within:ring-primary focus-within:ring-offset-2 focus-within:ring-offset-primary-new_light transition-all duration-150 ease-in-out"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.instruction.prompt),
      expression: "instruction.prompt"
    }],
    staticClass: "bg-transparent resize-none px-3 py-2 rounded-md focus:outline-none w-full",
    attrs: {
      "placeholder": "Enter a instruction prompt...",
      "rows": "2"
    },
    domProps: {
      "value": (_vm.instruction.prompt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.instruction, "prompt", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex justify-end items-center pb-2 px-2 text-xs"
  }, [_vm._v("\n            " + _vm._s(_vm.instruction.prompt.length) + " / 200\n          ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-end space-x-2"
  }, [_c('div', {
    staticClass: "flex items-center space-x-2"
  }, [_c('button', {
    staticClass: "px-4 py-2 text-gray-800 bg-white rounded-md hover:bg-gray-100 transition",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("\n          Cancel\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "px-4 py-2 bg-primary text-white rounded-md hover:bg-primary-dark transition",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        return _vm.handleSaveInstruction()
      }
    }
  }, [_vm._v("\n          Save\n        ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-5059c3ae!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/Dialogs/InstructionsFeedback/InstructionsFeedback.vue
// module id = 1281
// module chunks = 61